'use client';

import React from 'react';
import { UserPlus, ArrowLeft, ChevronRight } from 'lucide-react';
import { cn } from '@sharpr/ui';

interface EmptySelectionStateProps {
  className?: string;
  isPanelCollapsed?: boolean;
  onExpandPanel?: () => void;
}

export function EmptySelectionState({ 
  className,
  isPanelCollapsed = false,
  onExpandPanel
}: EmptySelectionStateProps) {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center h-full",
      className
    )}>
      <UserPlus className="w-20 h-20 mb-6 text-brand-400 dark:text-brand-500" />
      
      <h3 className="text-2xl font-semibold mb-3 text-gray-700 dark:text-text-primary">
        No Players Selected
      </h3>
      
      <p className="text-base text-center max-w-md mb-8 text-gray-400 dark:text-text-secondary leading-relaxed">
        {isPanelCollapsed 
          ? "Expand the player panel to start selecting players for comparison"
          : "Select players from the left panel to compare their projections side-by-side"
        }
      </p>

      {isPanelCollapsed && onExpandPanel && (
        <button
          onClick={onExpandPanel}
          className={cn(
            "flex items-center gap-2 px-6 py-3",
            "bg-brand-500 dark:bg-brand-600 text-white rounded-lg",
            "hover:bg-brand-600 dark:hover:bg-brand-500 transition-colors duration-200",
            "font-medium text-sm"
          )}
        >
          <ChevronRight className="w-4 h-4" />
          Expand Player Panel
        </button>
      )}

      {!isPanelCollapsed && (
        <ArrowLeft className="w-10 h-10 text-brand-300 dark:text-brand-600 animate-bounce-x" />
      )}
    </div>
  );
}